import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './PaQuickQuoteDriver-hashed.scss';
import templateStr from 'text!./PaQuickQuoteDriver.html';

export default [
    () => {
        return {
            restrict: 'E',
            scope: {
                isActive: '&',
                isPanelValid: '&',
                transitionFn: '&',
                flow: '=',
                driverAge: '=',
                termsChecked: '=',
                driversAllowedMinAge: '=',
                driversAllowedMaxAge: '='
            },
            template: cssUtil.hashTemplate(templateStr, styles),
            controller: ['$scope', ($scope) => {
                $scope.driverAge.value = $scope.driversAllowedMinAge;
            }]
        };
    }
];
